var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Banner'),_c('WhyUs'),_c('Services',{attrs:{"id":"services"}}),_c('Unleashing'),_c('Query')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }